import { render, staticRenderFns } from "./Capture.vue?vue&type=template&id=1ec7f1ba&"
import script from "./Capture.vue?vue&type=script&lang=js&"
export * from "./Capture.vue?vue&type=script&lang=js&"
import style0 from "./Capture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports